import React from 'react'
import PropTypes from 'prop-types'
import { LayerColorSelector }
  from '@eqworks/kepler.gl/dist/components/side-panel/layer-panel/layer-configurator'
import VisConfigSlider
  from '@eqworks/kepler.gl/dist/components/side-panel/layer-panel/vis-config-slider'
import LayerConfigGroup, { ConfigGroupCollapsibleContent }
  from '@eqworks/kepler.gl/dist/components/side-panel/layer-panel/layer-config-group'


const propTypes = {
  layer: PropTypes.object.isRequired,
  visConfiguratorProps: PropTypes.object.isRequired,
  layerConfiguratorProps: PropTypes.object.isRequired,
}

const _renderTileLayerConfig = ({
  layer,
  visConfiguratorProps,
  layerConfiguratorProps,
}) => (
  <div>
    {/* Color */}
    <LayerConfigGroup label='color' collapsible>
      <LayerColorSelector {...layerConfiguratorProps} />
      <ConfigGroupCollapsibleContent>
        <VisConfigSlider
          {...layer.visConfigSettings.opacity}
          {...visConfiguratorProps}
        />
      </ConfigGroupCollapsibleContent>
    </LayerConfigGroup>
  </div>
)

_renderTileLayerConfig.propTypes = propTypes

export default _renderTileLayerConfig
